// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--1VOYq","link":"styles-module--link--3z6-z"};